import { getAmplitudeInstance } from '../amplitudeHelpers';

type logMultiDayRouteTagClickedParams = {
  destination_trail_id: number;
  trail_id: number;
};

/**
 * User taps the 'Multi-day route' tag on a segment trail details page to navigate back to the parent multi-day route.
 * @param params - Attributes to log with the amplitude event
 * @param params.destination_trail_id - The trail id of the parent multi-day route the user is navigating to.
 * @param params.trail_id - The trail id of the segment trail details page where the tag was tapped.
 */
const logMultiDayRouteTagClicked = ({ destination_trail_id, trail_id }: logMultiDayRouteTagClickedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent('multi day route tag clicked', { 'destination trail id': destination_trail_id, 'trail id': trail_id }, callback);
};

export default logMultiDayRouteTagClicked;
